/**
 * Generates the notification warning for extra packages in the cross-selling section..
 *
 * @param product
 * @return {string}
 */
export default (product) => {
    // SSL and Uptime monitoring do not have extra package.
    if ([5, 6].includes(product?.product_id)) {
        return '';
    }
    return `Extra package available only if you go with the Extra package for ${product?.product_name ?? 'main product'}`;
}
